<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
  <p style="font-size: 20px; color: white">Aguarde ...</p>
</ngx-spinner>

<div class="container-fluid">
  <div class="row">
    <div class="col-12">
      <div class="card quer-participar-card">
        <div class="card-header d-flex justify-content-between align-items-center">
          <h4 class="card-title mb-0">
            <i class="feather icon-user-plus me-3"></i>
            &nbsp; &nbsp; Quer Participar
          </h4>
        </div>
        <div class="card-body">
          <div class="filters-section mb-4">
            <div class="row align-items-center">
              <div class="col-md-6">
                <div class="search-box">
                  <i class="feather icon-search"></i>
                  <input
                    type="text"
                    class="form-control"
                    [(ngModel)]="searchText"
                    (input)="onSearch()"
                    placeholder="Pesquisar por nome, telefone, criança, idade..."
                  />
                </div>
              </div>
              <div class="col-md-6 text-end">
                <span class="badge bg-teal">
                  <i class="feather icon-users me-1"></i>
                  {{ filteredLeads.length }} registros
                </span>
              </div>
            </div>
          </div>

          <div class="table-responsive quer-participar-table">
            <table class="table table-hover">
              <thead class="table-light">
                <tr>
                  <th class="col-1">ID</th>
                  <th class="col-3">Nome</th>
                  <th class="col-2">Telefone</th>
                  <th class="col-3">Nome da Criança</th>
                  <th class="col-1">Idade</th>
                  <th class="col-2">Data</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let lead of filteredLeads">
                  <td>{{ lead.idLead }}</td>
                  <td class="text-truncate">{{ lead.nome }}</td>
                  <td>{{ lead.telefone }}</td>
                  <td class="text-truncate">{{ lead.nomeCrianca }}</td>
                  <td>{{ lead.idade != null ? lead.idade : "-" }}</td>
                  <td>{{ lead.data | date: "dd/MM/yyyy HH:mm:ss" }}</td>
                </tr>
                <tr *ngIf="filteredLeads.length === 0">
                  <td colspan="6" class="text-center text-muted py-4">
                    Nenhum registro encontrado.
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
